export default {
  en: {
    oauth: {
      title: 'Authorize Access',
      requestingAccess: 'is requesting access to your Slate account.',
      scopeLabel: "What you're allowing",
      scopeMcp:
        'Works with your Slate tools and connected systems on your behalf, using your configured permissions',
      signedInAs: 'Signed in as',
      allow: 'Allow',
      deny: 'Deny',
      working: 'Working...',
      expiredError:
        'This authorization request has expired. Please start again from the app.',
    },
    sidebar: {
      viewTitle: 'View',
      viewSubtitle: 'Lists & Maps',
      generateTitle: 'Generate',
      generateSubtitle: 'Generate a Template',
      exportTitle: 'Export',
      exportSubtitle: 'Download as CSV',
      notifyTitle: 'Notify',
      notifySubtitle: 'Email and Webhooks',
      scriptsTitle: 'Scripts',
      scriptsSubtitle: 'Automate Slates with JS',
    },
    routes: {
      home: 'Home',
      profileSettings: 'Profile Settings',
      stackSettings: 'Stack Settings',
      administration: 'Administration',
      administrationShort: 'Admin',
      custom: 'Custom',
      customShort: 'Cust',
      apiKey: 'API Key',
      slateViews: 'Slate Views',
      slateViewSettings: 'Configuration',
      searchResults: 'Search Results',
      slateGenerator: 'Generate a Template with',
      notifications: 'Notifications',
      notificationNew: 'New Notification',
      notificationEdit: 'Edit Notification',
      export: 'Export',
      newExportJob: 'New Export Job',
      scripts: 'Scripts',
      inspect: 'Inspect',
      inspectNew: 'New Inspection',
      inspectSettings: 'Inspection Configuration',
      dynamicContent: 'Dynamic Content',
      slate: 'Slate',
      view: 'View',
      list: 'List',
      map: 'Map',
    },
    common: {
      profileSettings: 'Profile Settings',
      logOut: 'Log Out',
      stackSettings: 'Stack Settings',
      switchStack: 'Switch Stack',
      photo: 'Photo',
      now: 'Now',
      new: 'NEW',
      today: 'Today',
      color: 'Color',
      name: 'Name',
      item: 'item',
      confirmDelete: 'Confirm Delete',
      deleteConfirmMessage:
        'Are you sure you want to delete this {{itemType}}? This action cannot be undone.',
      typeNameToConfirm: 'Type the name to confirm: ',
    },
    btn: {
      contactUs: 'Contact Us',
      cancel: 'Cancel',
      cancelOperation: 'Cancel Operation',
      continue: 'Continue',
      acceptAndContinue: 'Accept and Continue',
      done: 'Done',
      delete: 'Delete',
      createProfile: 'Create Profile',
      logIn: 'Log In',
      addRule: 'Add Rule',
      addColor: 'Add Color',
      save: 'Save',
      saveRun: 'Save & Run',
      saveApiKey: 'Save API Key',
      addApiKey: 'Add API Key',
      updateStack: 'Update Stack',
      selectNewImage: 'Select New Image',
      clear: 'Clear',
      apply: 'Apply',
      map: 'Map',
      satellite: 'Satellite',
      close: 'Close',
      copy: 'Copy',
      create: 'Create',
      dismiss: 'Dismiss',
      open: 'Open',
      contactSupport: 'Contact Support',
    },
    content: {
      needAUserProfile: 'Need a User Profile?',
      createOneHere: 'Create one here',
      alreadyHaveAUserProfile: 'Already have a User Profile?',
      logInHere: 'Log in here',
      rememberYourPassword: 'Remember your password?',
    },
    login: {
      login: 'Login',
      emailOrPhone: 'Email or Phone',
      password: 'Password',
      logIn: 'Log In',
      loggingIn: 'Logging In...',
      signIn: 'Sign In',
      register: 'Register',
      recoverPassword: 'Recover password',
      forgotPassword: 'Forgot your password?',
      verificationCode: 'Verification Code',
      sentVerificationCode: "We've Sent a Verification Code",
      receiveVerificationCode:
        'You will receive a verification code sent to the email address associated with your profile. Enter that code below to continue.',
    },
    resetPassword: {
      resetPassword: 'Reset Password',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      updatePassword: 'Update Password',
      emailOrPhone: 'Email or Phone',
      sendVerificationCode: 'Send Verification Code',
      sendCode: 'Send Code',
      code: 'Code',
      continue: 'Continue',
      sendCodeAgain: 'Send code again',
      or: 'or',
      callMeInstead: 'call me instead',
      callAgain: 'Call again',
      smsTextMeInstead: 'SMS text to me instead',
      verification: 'Verification',
      willSendYouCode:
        "We'll send you a verification code to make sure it's really you",
      enterVerificationCode: 'Enter Verification Code',
      setNewPassword: 'Set New Password',
    },
    search: {
      search: 'Search',
      minLengthError: 'Enter at least {{length}} character to search',
    },
    tooltips: {
      copyToClipboard: 'Copy to Clipboard',
      autoRefresh: 'Auto Refresh (30s)',
      refresh: 'Refresh',
      refreshView: 'Refresh View',
      viewConfiguration: 'View Configuration',
      sharableViewLink: 'Sharable View Link',
      export: 'Export',
      rerunExportJob: 'Re-run Export Job',
      cloneToNewExportJob: 'Clone to New Export Job',
      favoriteThisJob: 'Favorite This Job',
      archiveThisJob: 'Archive This Job',
    },
    userProfile: {
      email: 'Email',
      phone: 'Phone',
      name: 'Name',
      displayName: 'Display Name',
      displayNameHint: 'How others will see you in Slate Pages',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      newPassword: 'New Password',
      currentPassword: 'Current Password',
      confirmNewPassword: 'Confirm New Password',
      createProfile: 'Create Profile',
      profileSettings: 'Profile Settings',
      updateProfile: 'Update Profile',
      profileDetails: 'Profile Details',
      updatePassword: 'Update Password',
      createProfileDisclaimer:
        'By tapping Create Profile you agree to our Privacy Policy and Terms of Use agreements',
    },
    stackSettings: {
      stackSettings: 'Stack Settings',
      basicInformation: 'Basic Information',
      stackName: 'Stack Name',
      stackLogo: 'Stack Logo',
      addStack: 'Add Stack',
      addStackToProfile: 'Add Stack to Your Profile',
      noStacksFound: 'No Stacks found',
      enterAStackAuthCode:
        'Enter a Stack authorization code ("auth code") to add it to your profile',
      apiKeys: 'API Keys',
      apiKey: 'API Key',
      apiKeyName: 'API Key Name',
      apiKeyConfirm: 'API Key Confirmation',
      deleteApiKeyConfirm: 'Delete API Key Confirmation',
      selectTheServices:
        'Select the services this API key will be using. To minimize surface attack risk, only choose the services necessary.',
      importSlates: 'Import Slates',
      endpointsForGettingInfo:
        'Endpoints for getting template information and importing slates',
      updateSlates: 'Update Slates',
      endpointForGettingDetails:
        "Endpoint for getting a slate's template details and updating slates.",
      storeKey:
        'Your key is like a password, so we will not show it to you again. Store it somewhere safe.',
      authCode: 'Auth Code',
      searchMyStacks: 'Search my Stacks',
      enterTheNameOfApiKey: 'Enter the name of the API key',
      confirmToDeleteIt: 'to confirm and delete it',
      thisInformationIsLinked:
        'This information is linked from your profile. To change them, go to your profile settings',
      here: 'here',
      createApiKey: 'Create API Key',
      createApiKeyDescription:
        'Enter a name for your new API key. This name will help you identify this key later.',
      apiKeyNamePlaceholder: 'e.g., Production Server',
      generatingKey: 'Generating Your API Key',
      generatingKeySubtitle: 'Creating a secure key for your application...',
      apiKeyCreated: 'API Key Created',
      apiKeyCreatedDescription:
        'Your API key has been created successfully. Copy and store it securely.',
      deleteApiKey: 'Delete API Key',
      deleteApiKeyMessage:
        'Are you sure you want to delete the API key "{{name}}"? This action cannot be undone.',
      noApiKeys: 'No API keys have been created yet.',
      permissions: 'Permissions',
      lastFourCharacters: 'Last 4 Characters',
    },
    errorDialog: {
      somethingWentWrong: 'Oops!',
      oops: "Well, that didn't work",
      friendlyMessage:
        "Something went wrong on our end. Give it another try, and if it keeps happening, we're here to help.",
      referenceCode: 'Reference Code',
      clickToCopy: 'Click to copy',
      copied: 'Copied!',
      getHelp: 'Get Help',
    },
    fileUploader: {
      clickToUpload: 'Drop image or click here to upload your image',
      avatarRequirements: '(JPEG or PNG, minimal size 200x200px)',
      clearPhoto: 'Clear Photo',
      removePhoto: 'Remove Photo',
      setProfilePhoto: 'Set Profile Photo',
      fileTypeNotSupported: 'This file type is not supported',
      imageSizeError: 'Image size should be at least 200x200px',
      imageTypeError: 'Only JPEG and PNG images are allowed',
    },
    verification: {
      alreadyHaveCode: 'Already have a verification code?',
      enterCodeHere: 'Enter code here',
      needVerificationCode: 'Need a verification code?',
      needVerificationEmail: 'Need a verification email?',
      getOneHere: 'Get one here',
      sendVerificationCode: 'Send Verification Code',
      sendVerificationEmail: 'Send Verification Email',
      code: 'Code',
      verify: 'Verify',
      verifyAndLogin: 'Verify and Log In',
      sendCode: 'Send Code',
      codeWillSentTo: 'Code will be sent to ',
      verify2fa: 'Enter Verification Code',
      sendAnotherCode: 'Send another code',
      didntReceiveCode: "Didn't receive a code yet?",
      emailTwoFactorAuthentication:
        '{{enabled}} Two Factor Authentication for Email',
      youWillBeSentCode:
        'You will be sent a code. Once you verify that code, 2FA will be {{enabled}}.',
      weSendYouCode:
        "We'll send you a verification code to the following phone number: ",
      weSendYouLink:
        "We'll send you a verification link to the following email: ",
      weSentYouLink:
        'We sent you a verification link to your email. When you receive it, click the link to complete the verification process.',
      sendCodeViaSms: 'Send Code via SMS',
      sendCodeViaCall: 'Send Code via Call',
      enterVerificationCode: 'Enter Verification Code',
      checkYourEmail: 'Check Your Email',
      weSentYouLConfirmationCode2fa:
        'Check your email, we sent you a confirmation code. Enter it below to {{enabled}} two factor authentication for email.',
      enterCodeWeSent:
        'Enter the verification code we sent to your phone number',
    },
    notifications: {
      successfullyLoggedIn: 'You have successfully logged in.',
      successfullyLoggedOut: 'You have successfully logged out.',
      successfullyCreateUser: 'You have successfully signed up.',
      successfullyUpdateUser: 'You have successfully update your info.',
      successfullyUpdateStack: 'You have successfully update your info.',
      successfullyUpdateProfile: 'Profile successfully updated',
      resetPasswordSentSMS:
        'Reset password code was sent in SMS. Please check your phone.',
      resetPasswordSentCall: 'You will receive a call in about 20 seconds.',
      resetPasswordSentEmail:
        'Reset password code was sent to your email. Please check your Inbox.',
      slateNotFound: 'Slate not found.',
      successfullySavedSlateViewSettings:
        'view configuration successfully saved.',
      successfullySavedInspectionSettings:
        'inspection configuration successfully saved.',
      inspectionRecordUpdated: 'Inspection record updated',
      inspectionRecordVoided: 'Inspection voided',

      successfullyAddStack: 'New Stack has been added.',
      successfullyAddAndSwitchStack: "New Stack added. You've been switched to",
      successfullyRemoveStack: 'Stack removed.',
      successfullyUpdateApiKey: 'Your API key has been updated.',
      successfullyRemoveApiKey: 'Your API key has been deleted.',
      successfullyRemoveSlateView: 'Your slate view has been deleted.',
      noLongerAccess: 'You no longer have access to',
      youHaveBeenSwitched: "You've been switched to",
      fieldCannotBeAdded:
        '{{name}} fields cannot be added as columns to a list view',
      notificationMustBeConfiguredBySlatePages:
        'This notification must be configured by Slate Pages. Contact us to make changes.',
      successfullySavedJob: 'job configuration successfully saved.',
      successfullyUpdateExportJob: 'Export job successfully updated.',
      rerunHasBeenStarted: 'rerun has been started',
      successfullyRemoveExportJob: 'export job successfully removed.',
      emptyRecord:
        'There are no entries on this Record field. To add entries, use the Slate Pages app.',
      slatesFilteringRulesMustBeRemoved: `Slate filtering rule{{moreThenOne}}: {{ruleTitlesList}} must be removed before 
        you can switch to a Slates list view.`,
      allSlatesFilteringRulesMustBeRemoved: `All slate filtering rules must be removed before 
        you can switch to a Record Entries list view.`,
      linkIsNotCorrect: `Link is not correct.`,
      doNotHavePermission: `You do not have permission to view this link..`,
      allListColumnsMustBeRemoved: `All list columns must be removed before you can switch 
        to a Record Entries list view.`,
      yourRecordEntryColumnsAreStillSelected: `Your record entry columns are still selected. 
        Use the List Columns section to configure columns for your list view based on your slates.`,
      toExportListView: `To export a List View select at least one column to display in your list.`,
      emptyRuleValue: `Make sure all your rules have values before saving.`,
      youChooseNewOptionButTheFollowingFieldsAreNotAvailable: `You choose {{newOption}}, but the following fields are not available in that list. Adjust your configuration below so that these fields are not being used: {{selectedFields}}`,
      toSaveListView: `To save a List View select at least one column to display in your list.`,
      geocoderError: 'Google Geocoder error.',
      geocoderErrorNoResults: 'Google Geocoder error: no results.',
      notificationWasChangedSuccessfully: 'Notification saved successfully.',
      notificationWasCreatedSuccessfully: 'Notification created successfully.',
      notificationWasDeletedSuccessfully:
        'The notification was deleted successfully',
      copyToClipboardSuccessfully:
        'The link was successfully copied to the clipboard',
      copyTableToClipboardSuccessfully:
        'The table was successfully copied to the clipboard.',
      copyDataToClipboardSuccessfully:
        'The data was successfully copied to the clipboard.',
      copyDataToClipboardFailed: 'The data was NOT copied to the clipboard.',
      copyTableToClipboardUnsuccessfully:
        'Copying of the table is unsuccessful. Please try again.',
      templateSlateSaved: 'Template saved successfully.',
      slatePaneSaved: 'Changes saved.',
      slatePaneTemplateSaved: 'Template saved.',
      slatePaneDemoSaved: 'Demo saved.',
      slatePaneSlateSaved: 'Slate saved.',
    },
    messages: {
      invalidAuthCode: 'Invalid Auth Code',
      userAlreadyExists:
        'An account with this email or phone already exists. Try logging in instead.',
      userNotFound: 'User not found.',
      tooMany2faCodeRequests:
        'Too many login attempts have been made in too short of a time period. Wait a few moments and try again.',
      invalidCredentials: 'Login credentials were not valid. Please try again.',
      userDoesNotExist: 'User does not exist',
      unableToSendVerificationCode: 'Unable to send verification code',
      userDoesntExistCode: "User doesn't exist",
      tooManyCodesSent: 'too many codes sent',
      stackAlreadyExists: 'This Stack is already available on your profile',
      genericError: 'Something went wrong. Please try again.',
      changedWhileSaving: 'This item was changed while you were saving. Reload and try again.',
    },
    settings: {
      share: 'Share',
      sourceTitle: 'Show:',
      sourceSubtitle: 'This determines what fields to show in options below',
      lossOfConfiguredOptions: 'Loss of Configured Options',
      popupMessageStart: 'You selected to show',
      popupMessageEnd:
        'fields, but some of configured options contain fields not in this list. Below is a summary of those options. If you proceed, these options will be removed from your configuration. Would you like to continue?',
      dialogRecordsListTitle: 'Select a Records Field on your Stack: ',
      dialogRulesListTitle: 'Rule for: ',
      dialogColumnsListTitle: 'Column:  ',
      basicInformation: 'Basic Information',
      slateViewTitle: 'View name',
      autoRefreshTable: 'Auto-Refresh',
      autoRefreshListView: 'Auto-Refresh Every 30 seconds',
      slateFilteringRules: 'Slate Filtering Rules',
      defineIncludedSlates: 'Define how slates will be included in this view',
      pinColors: 'Pin Colors',
      definePinColors: 'Define how pins will be colored in this view',
      listColumns: 'List Columns',
      toDisplayInYourList: 'To display in your list',
      match: 'Match',
      matchPins: 'all pins matching',
      ofTheFollowingRules: 'of the following rules',
      selectField: 'Select field',
      selectOperator: 'Select operator',
      selectPattern: 'Select pattern',
      enterValue: 'Enter value',
      selectDate: 'Select date',
      selectTime: 'Select time',
      selectDateTime: 'Select Date & Time',
      available: 'Available',
      selected: 'Selected',
      availableFieldsSelect: {
        label: 'Show:',
        options: {
          all_fields: 'All fields',
          template_fields: 'Template Fields',
          slate_fields: 'Slate Fields',
        },
      },
      all: 'All',
      any: 'Any',
      additionalOptions: 'Additional Options',
      includeUrl: 'Include URL Column',
      includeUrlDescr:
        'A column containing the URL link of each slate will be included',
      includeUUID: 'Include Identifier Column',
      includeUUIDDescr:
        'A column containing the identifier of each slate will be included',
      includeHeaderRow: 'Include Header Row',
      includeHeaderRowDescr:
        'The first row will contain the names of each column',
      newView: 'New View',
      configuration: 'Configuration',
      newListViewConfiguration: 'New List View Configuration',
      newMapViewConfiguration: 'New Map View Configuration',
      // operators
      equals: 'Equals',
      doesntEqual: "Doesn't Equal",
      contains: 'Contains',
      doesntContain: "Doesn't Contain",
      lessThan: 'Less Than',
      lessThanEqualTo: 'Less Than or Equal To',
      greaterThan: 'Greater Than',
      greaterThanEqualTo: 'Greater Than or Equal To',

      existsOnSlate: 'Exists On Slate',
      doesntExistOnSlate: "Doesn't Exist On Slate",
      hasValue: 'Has Value',
      doesntHaveValue: "Doesn't Have Value",
      allTheLessThan: 'All the less than',
      allTheGreaterThan: 'All the greater than',
      configureAnExportJob:
        'Would you like to configure an export job based on this view?',
      export: 'Export',
      confirmToDeleteIt: 'to confirm and delete it',
      enterTheNameOfSlateView: 'Enter the name of the view',
      deleteConfirm: 'Delete Slate View Confirmation',
      slateViewName: 'View name',
      viewNameRequired: 'View name is required',
      deleteView: 'Delete View',
      fieldAttribute_value: 'Value',
      fieldAttribute_user: 'User',
      fieldAttribute_timestamp: 'Timestamp',
      fieldAttributeInUse: 'in use',
      slateDetails: 'Slate Details',
      fieldsFor: 'Fields for ',
      otherFields: 'Other Fields',
      slateFields: 'Slate Fields',
      whatDataWouldYouLike:
        'What data would you like to see in your list view?',
      slates: 'Slates',
      recordEntries: 'Record Entries',
      selectRecord: 'Select a Records Field on your Stack',
      thisListViewWillShow:
        'This list view will show entries for this field across all your slates',
      selectRecordField: `Select a records field in the Basic Information section,
        then you'll be able to select from a list of fields here`,
      // Column picker
      availableFields: 'Available Fields',
      editColumns: 'Edit Columns',
      editListColumns: 'Edit List Columns',
      columnSelected: 'column selected',
      columnsSelected: 'columns selected',
      noColumnsSelected: 'No columns selected',
      removeAll: 'Remove All',
      removeAllTitle: 'Remove All Columns',
      removeAllMessage:
        'This will remove all {{count}} columns from your selection.',
      removeAllConfirm: 'Remove {{count}} Columns',
      dropColumnHere: 'Drop column here',
      columnsAdded: 'Added {{count}} columns',
      noColumnsToAdd: 'All fields are already added',
      addColumn: 'Add Column',
      addColumns: 'Add Columns',
      columnSingular: 'column',
      columnPlural: 'columns',
      previewEmptyMessage: 'Add columns to see a preview',
      applyColumns: 'Apply',
      columnPreview: 'Preview',
      searchFields: 'Search fields...',
      noFieldsFound: 'No fields found',
      bulkAddTitle: 'Column Quick-Add Confirmation',
      bulkAddMessage:
        'The following fields from "{{name}}" will be added as columns:',
      bulkAddSearchResults: 'Search results ({{count}})',
      bulkAddAllFields: 'All fields ({{count}})',
      bulkAddConfirm: 'Add {{count}} Columns',
      bulkAddAlreadyAdded: 'already added',
    },
    slateView: {
      autoRefresh:
        'Auto-Refresh temporarily enabled. You can permanently enable it in the view configuration.',
      list: 'List',
      map: 'Map',
      views: '{{type}} Views',
      publicView:
        'Use this link to provide public access to this view. Users will be able to view slates, ' +
        "but they will only have 'public' access (based on each Slate's public permissions).",
      cancelCopyTitle: 'Cancel Copy?',
      cancelCopyMessage:
        'Data is still being loaded. Do you want to cancel the copy operation?',
      copyReadyTitle: 'Data Ready',
      copyReadyMessage:
        'All data has been loaded. Click Copy to copy to clipboard.',
    },
    slateViews: {
      searchViews: 'Search views...',
      createView: 'Create View',
      createNewView: 'Create New View',
      listView: 'List View',
      mapView: 'Map View',
      listViewDescription: 'Display Slates in a sortable table format',
      mapViewDescription: 'Visualize Slates on an interactive map',
      noViewsTitle: 'No Views Yet',
      noViewsDescription:
        'Create your first view to display your Slates as a list or map. Views help you organize and visualize your data.',
    },
    mapView: {
      emptyStateTitle: 'No Locations to Display',
      emptyStateDescription:
        'Slates in this view do not have location data. Add coordinates or addresses to your Slates to see them on the map.',
    },
    listView: {
      emptyStateTitle: 'No Slates to Display',
      emptyStateDescription:
        'This view does not contain any Slates yet. Create Slates to see them listed here.',
    },
    slate: {
      slateIdentityInformation: 'Slate Identity Information',
      slateUrl: 'Slate URL',
      openLink: 'Open Link',
      qrCode: 'QR Code',
      on: 'on',
      coordinates: 'Coordinates',
      address: 'Address',
      latitude: 'Latitude',
      longitude: 'Longitude',
      convertToAddress: 'Convert to Address',
      convertToCoordinates: 'Convert to Coordinates',
      dropImageHere: 'Drop image here or press Select New Image button below',
      edit: 'Edit',
      copy: 'Copy',
      downloadCalendarEvent: 'Download Calendar Event',
      copyAddress: 'Copy Address',
      copyCoordinates: 'Copy Coordinates',
      showInMaps: 'Show In Maps',
      getDirections: 'Get Directions',
      openInBrowser: 'Open In Browser',
      sendEmail: 'Send Email',
      call: 'Call',
      message: 'Message',
      view: 'View',
      download: 'Download',
      viewAllEntries: 'View All Entries',
      viewLastEntry: 'View Last Entry',
      viewHistoryEntries: 'View History',
      addEntry: 'Add Entry',
      noSlateViews: 'There are no slate views.',
      journalEntries: 'Journal Entries',
      recordEntries: 'Record Entries: {{fieldName}}',
      recordEntry: 'Record Entry',
      lastEntry: 'Last Entry',
      enterAnAddress: 'Enter an address and/or coordinates above to begin',
      poweredBy: 'Powered by',
    },
    history: {
      title: 'History: {{fieldName}}',
      empty: 'History is empty',
      columnTimestamp: 'Timestamp',
      columnUser: 'User',
      columnValue: 'Value',
    },
    slateGenerator: {
      warning:
        'Please be aware that your Stack administrator may be invoiced if total number of Slates on Stack exceeds purchased quantity.',
      slateGenerator: 'Generate a Template with',
      hereIsANewSlate: "Here's your new slate:",
      generateNewSlate: 'Generate New Slate',
      slateUUID: 'Slate UUID',
      url: 'URL',
      qrCode: 'QR Code',
      tabSlateQR: 'Slate QR',
      tabSlateMate: 'SlateMate',
      slateMateHintPrimary: 'Attach up to 3 files (PDF, images) for context.',
      slateMateHintSecondary:
        'Add details for accuracy, or go broad and let SlateMate surprise you.',
      slateMatePromptPlaceholder1:
        "Start anywhere — we'll figure it out as we go...",
      slateMatePromptPlaceholder2:
        "Doesn't have to be perfect — just start somewhere...",
      slateMatePromptPlaceholder3:
        "Toss out an idea — we'll build from there...",
      slateMatePromptPlaceholder4:
        "Even half an idea is enough — let's start there...",
      slateMatePromptPlaceholder5:
        'No need to nail it on the first try — start anywhere...',
      slateMatePromptPlaceholder6:
        "Just start typing — we'll work it out together...",
      slateMatePromptPlaceholder7:
        "Don't overthink it — a rough idea is plenty to start...",
      slateMatePromptPlaceholder8:
        "Start with whatever comes to mind — we'll shape it together...",
      slateMatePromptPlaceholder9: 'A few words is enough to get started...',
      slateMatePromptPlaceholder10:
        "Start messy — we'll clean it up as we go...",
      slateMateWelcomeSubtitlePrimary:
        'Attach a sample, pick a starting point, or describe your own.',
      slateMateWelcomeSubtitleSecondary:
        'Add details for accuracy, or go broad and let SlateMate surprise you.',
      slateMateSuggestionConvertForm: 'Convert a PDF form',
      slateMateSuggestionConvertFormHint:
        'Drop in an existing paper or PDF form and SlateMate will rebuild it as a digital slate, field by field.',
      slateMateSuggestionPrestartInspection: 'Equipment pre-start inspection',
      slateMateSuggestionPrestartInspectionHint:
        'A pre-shift safety check for vehicles, machines, or tools — pass/fail items, photo capture, and operator sign-off.',
      slateMateSuggestionProductionStages: 'Production stage tracking',
      slateMateSuggestionProductionStagesHint:
        'Move work orders through stages like Cut, Assemble, QC, and Ship — capture timestamps and notes at each step.',
      slateMateSuggestionRoutineWalkthrough: 'Routine facility walkthrough',
      slateMateSuggestionRoutineWalkthroughHint:
        'A repeatable site or facility round with checkpoints, condition ratings, and follow-up tasks for anything flagged.',
      slateMateThinking: 'Thinking...',
      slateMateGenerate: 'Generate',
      slateMateGenerating: 'Generating...',
      slateMateAttachFiles: 'Attach Files',
      slateMateDropFiles: 'Drop files here',
      slateMateMaxFiles: 'Maximum 3 files allowed',
      slateMateMaxFileSize: 'File must be under 10MB',
      slateMateImageTooLarge:
        'This image is too large to process. Please use an image under 100 megapixels.',
      slateMateFileReadFailed:
        'This file could not be read. Please try a different file.',
      slateMateInvalidFileType:
        'Only PDF, PNG, JPEG, GIF, and WebP files are accepted',
      slateMateGenerateError: 'Failed to generate slate. Please try again.',
      slateMateCancel: 'Cancel',
      slateMateFilesLost:
        'Your attached files could not be saved. Please re-attach them if needed.',
      slateMatePreviewTitle: 'Preview',
      slateMateStartOver: 'Start Over',
      slateMateStartOverTitle: 'Start Over?',
      slateMateStartOverMessage:
        'This will clear your prompt, attached files, and close the template preview. Are you sure you want to start over?',
      slateMateRegenerateTitle: 'Regenerate Slate?',
      slateMateRegenerateMessage:
        'You have unsaved changes to the current template. Generating a new slate will overwrite them.',
      slateMateRegenerate: 'Generate Anyway',
      // SlateMate chat (multi-turn)
      slateMatePromptPlaceholderActive: 'Reply or refine...',
      slateMateSend: 'Send',
      slateMateStopped: 'Stopped',
      slateMateRetry: 'Retry',
      slateMateNewMessages: 'Jump to Latest',
      slateMateInterruptedMessage: 'Stopped',
      slateMateLoopLimitMessage: "Couldn't complete that - try simplifying.",
      slateMateCoordinatorFailedMessage: 'Something went wrong. Please retry.',
      slateMateInvalidSlateMessage:
        'Save error - reloading the latest slate. Please retry.',
      slateMateGenericNetworkError: 'Network error. Please retry.',
      slateMateAttachmentCounter: 'Attachments: {{count}}/10',
      slateMateSessionBusy: 'Still working on the previous message.',
      slateMateTakingAWhile: 'This is taking a while...',
      slateMateStillWorking: '(still working on it)',
      slateMateRecovering: 'Still working on your Slate...',
      slateMateStillBuilding: 'Your Slate is still being built. Refresh in a minute to see it.',
      slateMateDocumentCapExceeded:
        'Attachment limit reached for this conversation.',
      slateMateValidationError: 'Please check your input and try again.',
      slateMateTimeoutError: 'Took too long to respond. Please retry.',
      slateMateAttachmentPerRequestCap: 'Maximum 3 files per message.',
      slateMateStartOverChatTitle: 'Start Over',
      slateMateStartOverChatMessage:
        'This will clear the conversation, the slate template, and any attached files. Are you sure?',
      chatSessionExpired: 'Conversation expired, starting fresh.',
      qrCodeTooltip: 'Generate QR Code',
      qrDialogTitle: 'Slate QR Generator',
    },
    slateViewSearch: {
      searchResultsHint: 'Search results for ',
      emptyResult: 'No results found for search criteria',
    },
    export: {
      exportJobs: 'Export Jobs',
      createNewExportJob: 'Create New Export Job',
      active: 'Active',
      favorites: 'Favorites',
      archived: 'Archived',
      name: 'Name',
      date: 'Date',
      status: 'Status',
      downloadCSV: 'Download CSV',
      newExportJob: 'New Export Job',
      exportJobName: 'Export job name',
      whatDataForExport: 'What data would you like to see in your export?',
      defineIncludedSlatesExport:
        'Define how slates will be included in this export',
      exportColumns: 'Export Columns',
      toIncludeInExport: 'To include in your export file',
      rerunExportJob: 'Rerun Export Job?',
      rerunTheExportJob: 'Re-run the export job',
      rerunJobNow: 'Rerun Job Now',
      cancel: 'Cancel',
      copyToNewExportJob: 'Copy to New Export Job?',
      copyExportJob: 'Copy export job',
      youWillBeAbleToCustomize:
        "to a new job? You'll be able to customize the settings before running it.",
      copyToNewJob: 'Copy to New Job',
      archiveExportJob: 'Archive Export Job',
      archiveTheExportJob: 'Archive the export job',
      fromRecentAndFavorites:
        'from Recents and Favorites? Note: It will still be available under the Archived tab.',
      deleteExportJob: 'Delete Export Job',
      permanentlyDeleteExportJob: 'Permanently delete export job',
      thisCannotBeUndone: 'This cannot be undone.',
      timeZoneWarning:
        'Dates and times will be exported in the selected timezone.',
      noRecentJobs: 'No Recent Export Jobs',
      noRecentJobsDescription:
        'Create a new export job to get started. Your recent exports will appear here.',
      noFavoriteJobs: 'No Favorite Jobs',
      noFavoriteJobsDescription:
        'Star your frequently used export jobs to find them quickly here.',
      noArchivedJobs: 'No Archived Jobs',
      noArchivedJobsDescription: 'Archived export jobs will appear here.',
    },
    notificationsPage: {
      title: 'Notifications',
      addNotificationButton: 'Add Notification',
      emptyStateTitle: 'No Notifications Yet',
      emptyStateDescription:
        'Set up notifications to receive alerts when your Slates change or on scheduled dates.',
      triggerType: 'Trigger Type',
      slateChanges: 'Slate Changes',
      dateFieldReminder: 'Date Field Reminder',
      deliveryType: 'Delivery Type',
      webhook: 'Webhook',
      email: 'Email',
      triggerTypes: {
        slateChanges: 'Slate Changes',
        dateField: 'Date Field Reminder',
      },
      deliveryTypes: {
        email: 'Email',
        webhook: 'Webhook',
      },
      newNotification: 'New Notification',
      editNotification: 'Edit {{name}}',
      deleteNotification: 'Delete Notification',
      notification: 'notification',
      deleteNotificationPopup: {
        title: 'Delete Notification',
        subtitle:
          'Enter the name of the notification ({{name}}) to confirm and delete it:',
        popupInputTitle: 'Name',
        message:
          'This will permanently delete the notification "{{name}}". This action cannot be undone.',
      },
      basicInformationCard: {
        title: 'Basic Information',
        inputTitle: 'Name',
        selectorTitle: 'Select Date Field',
      },
      filteringRulesCard: {
        title: 'Filtering rules',
      },
      alertsCard: {
        title: 'Alerts',
        subtitle: 'Configure when alerts should be sent out',
        addRowButtonTitle: 'Add Alert',
        timeNotification: 'Time of day to deliver alerts',
        number: 'Number',
        period: 'Period',
        alertPart1: 'number of',
        alertPart2: 'before date.',
      },
      deliveryAddressesCard: {
        title: 'Delivery Addresses',
        subtitle:
          'Specify a list of email addresses this alert will be sent to',
        addNewEmailButtonTitle: 'Add Email',
        newEmail: 'New Email',
        editEmail: 'Edit Email',
        inputTitle: 'Email',
      },
      tableTitles: {
        name: 'Name',
        dateField: 'Date Field',
        configuredAlerts: 'Configured Alerts',
        emailDeliversTo: 'Email Delivers To',
        actions: 'Actions',
        triggerType: 'Trigger Type',
        deliveryType: 'Delivery Type',
      },
      validationErrors: {
        uniqueValues: 'All values must be unique.',
        notEmptyList:
          'This list cannot be empty. Please add at least one entry.',
        notEmptyEmailsList: 'At least one email is required',
        notEmptyAlertsList: 'At least one alert is required',
        notEmptyValues: 'Values cannot be empty',
        requiredName: 'Name is required',
        requiredDateField: 'A valid date field from this Stack is required',
        requiredAlertTime:
          'Time of day your alert will be delivered is required',
        validationsFailed: 'Validations failed',
        namesDontMatch: "The names don't match",
      },
    },
    validation: {
      invalidLatitude: 'Invalid latitude',
      invalidLongitude: 'Invalid longitude',
      required: 'This field is required',
      nameMustMatch: 'Name must match exactly',
    },
    scripts: {
      noScriptsTitle: 'No Scripts Yet',
      noScriptsDescription:
        'Create your first script for automation in a Slate.',
      createScript: 'Create Script',
      scriptName: 'Name',
      scriptUuid: 'Script UUID',
      saveScript: 'Save',
      discardChangesTitle: 'Discard Changes?',
      discardChangesMessage:
        'You have unsaved changes to this script. If you cancel, your changes will be lost.',
      discardChanges: 'Discard Changes',
      keepEditing: 'Keep Editing',
      unsavedChangesTitle: 'Unsaved Changes',
      unsavedChangesNewMessage:
        'You have unsaved changes to the current script. Creating a new script will discard these changes.',
      discardAndCreate: 'Discard and Create',
      copiedToClipboard: 'UUID copied to clipboard.',
      testScript: 'Test with a Slate',
      newTestSlate: 'New Test Slate',
      hotReload: 'Hot Reload',
      showSlate: 'Show Slate',
      selectTemplateTitle: 'Select Template',
      selectTemplateDescription:
        'Choose one of the templates on this Stack. A test slate will be generated with this template, along with the script automation pre-loaded with your script.',
      noTemplatesTitle: 'No Templates Yet',
      noTemplatesDescription:
        "This Stack doesn't have any templates yet. Use the Slate app to create a template, then come back here to test your script.",
      runTest: 'Load Test Slate',
      testError: 'Failed to generate test slate.',
      openScript: 'Open Script',
      openTabStack: 'Stack',
      openTabComputer: 'Computer',
      openStackEmpty: 'No Scripts Saved',
      openStackEmptyDescription:
        'Scripts saved to this Stack will appear here.',
      openComputerDescription:
        'Drop a script file here, or browse to select one.',
      openComputerHint: 'Accepts .js, .ts, and .txt files',
      openComputerBrowse: 'Browse Files',
      openFileError: 'Could not read file.',
      openScriptError: 'Could not load script.',
      discardAndOpen: 'Discard and Open',
      unsavedChangesOpenMessage:
        'You have unsaved changes to the current script. Opening a new script will discard these changes.',
      saveAs: 'Save As',
      saveSuccess: 'Script saved.',
      saveError: 'Could not save script.',
      validationErrors: 'Validation Errors',
      validatingStep: 'Validating Script',
      savingStep: 'Saving to Stack',
      savingTitle: 'Saving...',
      saveProgressHint: 'This may take a few moments...',
      manageScripts: 'Manage Scripts',
      manageEmpty: 'No Scripts',
      manageEmptyDescription: 'Scripts saved to this Stack will appear here.',
      scriptItemType: 'script',
      deleteScriptTitle: 'Delete Script',
      deleteScriptMessage:
        'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
      deleteSuccess: 'Script deleted.',
      deleteError: 'Could not delete script.',
      noScriptOpenTitle: 'No Script Open',
      noScriptOpenDescription:
        'Open an existing script or create a new one from the File menu.',
      getStartedTitle: 'Get Started',
      getStartedDescription:
        'Create a new script or load an existing one from the File menu.',
    },
    inspect: {
      deficiencyMarkDeficient: 'Mark as Failed',
      deficiencyCloseOut: 'Mark Corrected',
      deficiencyRevert: 'Revert to Computed',
      deficiencyNoteReason: 'Reason',
      deficiencyNoteCorrectiveAction: 'Corrective Action Taken',
      deficiencyNoteOptional: 'Note (Optional)',
      deficiencyCancel: 'Cancel',
      deficiencyPickInspection: 'Open the inspection to change this record.',
      logMarkedDeficient: 'Marked as Failed',
      logCorrected: 'Corrected',
      logReverted: 'Reverted to Computed',
      logResult: 'Result',
      logMarkedDeficientDetail: 'Marked as failed',
      logRevertedDetail: 'Reverted to computed result',
      activityLogTitle: 'Activity Log',
      activityLogEmpty: 'No activity yet.',
      activityLogLoadFailed: 'Could not load the activity log.',
      activityBy: 'by',
      manualBadge: 'Manual',
      rowActionsAria: 'Record actions',
      viewLog: 'View Log',
      originalInspectorUnknown: 'Original inspector unknown',
      voidBadge: 'Void',
      amendedBadge: 'Amended',
      activityCompleted: 'Completed',
      activityAmended: 'Amended',
      activityVoided: 'Voided',
      activityPhotoResolved: 'Photo Resolved',
      activityResultChange: 'Result: {before} to {after}',
      activityCreationActor: 'Created by {name}',
      activityLastEditorAtBackfill: 'Last edited by {name} before this was tracked',
      activityDeferredEditRegistered: 'Photo pending',
      voidInspection: 'Void Inspection',
      voidInspectionBody:
        'The inspection stays in History, marked Void, but no longer counts as a completion for this asset. This cannot be undone.',
      voidReason: 'Reason',
      voidPreviewHeading: "Effect on This Asset's Schedule",
      voidPreviewLoading: 'Checking the effect on the schedule…',
      voidPreviewNextDue: 'Next Due: {before} -> {after}',
      voidPreviewLastInspected: 'Last Inspected: {before} -> {after}',
      voidPreviewNoChange: "Voiding does not change this asset's schedule.",
      voidPreviewNone: 'None',
      voidBeingUpdated: 'This inspection is being updated. Try again.',
      sidebarTitle: 'Inspect',
      sidebarSubtitle: 'Track & Verify Assets',
      recordsTab: 'Records',
      performanceTab: 'Performance',
      searchInspections: 'Search inspections...',
      noInspectionsFound: 'No inspections found',
      createInspection: 'New Inspection',
      noInspectionsSelector: 'No Inspections',
      noInspectionsTitle: 'No Inspections Configured',
      noInspectionsDescription:
        'Create an inspection configuration to start tracking asset inspections.',
      noRecordsTitle: 'No Inspection Records Yet',
      noRecordsDescription:
        'Records will appear here as inspections are submitted.',
      noMatchingRecordsTitle: 'No Matching Records',
      noMatchingRecordsDescription:
        'No records match the current filters. Try adjusting them above.',
      dateColumnLabel: 'Entry Date',
      summaryColumnInfoAria: 'About the Summary column',
      summaryColumnInfoTitle: 'About Inspection Summaries',
      summaryColumnInfoBody:
        'SlateMate reads each submitted inspection and writes a short recap of the result. Summaries are AI-generated and may not capture every detail -- open a record to see the full inspection.',
      dateFilterEmptyHint: 'Pick a date or range',
      clearColumnFilter: 'Clear {name} filter',
      performancePlaceholder: 'Performance metrics coming soon.',
      settingsTooltip: 'Inspection Configuration',
      settingsTitle: 'Inspection Configuration',
      newInspection: 'New Inspection',
      editInspection: 'Edit Inspection',
      sectionInspectionData: 'Inspection Data',
      inspectionDataDescription:
        'Select the records field whose entries will be inspected.',
      inspectionTargetRecordsHint:
        'Each entry in the selected records field is an inspection. The pass/fail rules run against those entries.',
      sectionPassFail: 'Pass/Fail Criteria',
      passFailDescription:
        'Define rules that determine whether an inspection passes or fails.',
      passRules: 'Pass Rules',
      failRules: 'Fail Rules',
      passRulesHint:
        'Entries matching these rules will pass. Everything else fails.',
      failRulesHint:
        'Entries matching these rules will fail. Everything else passes.',
      sectionAssetType: 'Asset Type',
      assetTypeDescription:
        'Optionally select a field that represents the asset type for performance breakdowns',
      assetTypeValueLabel: 'Value',
      assetTypeValueHint:
        'Limit this inspection to records where the selected field equals this value.',
      assetTypeValueDisabledHint: 'Select a field above first.',
      sectionRecurrence: 'Recurrence',
      sectionActiveInactive: 'Active/Inactive',
      activeInactiveDescription:
        'Optionally select a boolean field to track whether an asset is currently active or inactive',
      activeInactiveScopeHint:
        'This only affects what you see in the Performance and Scheduled tabs. History will continue to show inactive assets.',
      sectionNeglectWarnings: 'Neglect Warnings',
      sectionColumns: 'Columns',
      columnsDescription: 'Add your own fields as columns in the History and Scheduled tables.',
      sectionColumnsSummaryCount: '{{count}} custom column',
      sectionColumnsSummaryCount_plural: '{{count}} custom columns',
      sectionColumnsDefault: 'Default columns',
      columnsTabHistory: 'History',
      columnsTabScheduled: 'Scheduled',
      columnsRecordFieldsHistory: 'Inspection record fields',
      columnsRecordFieldsScheduled: 'Inspection template fields',
      columnsAssetFields: 'Asset fields',
      columnsOrphanTitle: 'Field no longer available',
      columnsOrphanMessage: 'Field no longer available: {{name}}',
      columnsRemove: 'Remove',
      columnsApply: 'Apply Columns',
      columnsNeedsRecordsField: 'Choose the inspection data first to add inspection record fields.',
      columnsErrorLine: '{{tab}}: {{name}}: {{message}}',
      saveConflictTitle: 'Inspection Changed',
      saveConflictMessage:
        'Someone else changed this inspection while you were saving, so nothing was saved. Reloading loads the latest version and discards your unsaved edits.',
      saveConflictMessageNew:
        'Another save on this inspection was in progress, so nothing was saved. Your edits are still here. Save again to retry.',
      saveConflictReload: 'Reload',
      builtinColumnAssetName: 'Asset Name',
      builtinColumnInspection: 'Inspection',
      builtinColumnLastChangedBy: 'Last Changed By',
      builtinColumnResult: 'Result',
      builtinColumnDueDate: 'Due Date',
      builtinColumnStatus: 'Status',
      builtinColumnFrequency: 'Frequency',
      builtinColumnLastInspected: 'Last Inspected',
      neglectWarningsDescription:
        'Optionally flag assets as neglected if no inspection is logged within a specified time period',
      sectionNotifications: 'Notifications',
      sectionComingSoon: 'Coming Soon',
      sectionComingSoonSubtitle: 'Available in a future release',
      performanceComingSoonTitle: 'Coming Soon',
      performanceComingSoonDescription:
        'Inspection performance metrics will appear here in a future release.',
      perfOverview: 'Overview',
      perfHealthTitle: 'Health Score',
      perfPassRate: 'Pass Rate',
      perfGrade_good: 'Good',
      perfGrade_fair: 'Fair',
      perfGrade_poor: 'Poor',
      perfKpiTotal: 'Total',
      perfKpiPassed: 'Passed',
      perfKpiOpenDeficiencies: 'Open Deficiencies',
      perfKpiOverdue: 'Overdue',
      perfKpiUpcoming: 'Upcoming',
      perfKpiNeglected: 'Neglected',
      perfSubCorrected: '{n} corrected',
      perfChipOverdue: '{n} Overdue',
      perfChipNeglected: '{n} Neglected',
      perfChipOpenDeficiencies: '{n} Open Deficiencies',
      perfFactorCompletion: 'Completion',
      perfFactorOnSchedule: 'On Schedule',
      perfInfoTitle: 'How Health Score Is Calculated',
      perfInfoDefPassRate: 'Graded inspections that passed or were corrected',
      perfInfoDefCompletion: 'Inspections finished and graded',
      perfInfoDefOnSchedule: 'Scheduled inspections not overdue',
      perfInfoNoData: 'No data',
      perfInfoPts: '{n} pts',
      perfInfoWeight: '{n}% of score',
      perfInfoNeglectTitle: 'Neglect Penalty',
      perfInfoNeglectRule: '-3 pts each, max -15',
      perfInfoNeglectCount: '{n} neglected',
      perfInfoNeglectPending: 'Not reported yet',
      perfInfoTotal: '{c} - {p} penalty',
      perfInfoThresholds: 'Good 75+ · Fair 50-74 · Poor below 50',
      perfSubOfTotal: 'of {n} total',
      perfSectionInspection: 'Pass Rate by Inspection',
      performanceNoDataTitle: 'No Inspection Data Yet',
      performanceNoDataDescription:
        'Performance metrics will appear here as inspections are submitted.',
      perfHealthEmptyTitle: 'No Score Yet',
      perfHealthEmptySub: 'Pass rate appears once an inspection is submitted.',
      perfSwitchTitle: 'Switch Inspection',
      perfSwitchConfirm: 'Switch',
      perfSwitchMsg:
        'Switch Inspect to "{name}"? All tabs will show only this inspection.',
      scheduledEmptyTitle: 'No Upcoming Inspections',
      scheduledEmptyDescription:
        'Inspections will appear here as they come due.',
      scheduledDueToday: 'Due Today',
      tabReports: 'Reports',
      reportsEmptyTitle: 'Reports Are Coming Soon',
      reportsEmptyDescription:
        'Soon you will be able to generate downloadable reports in PDF and Excel formats, right from this tab.',
      notificationsEmptyTitle: 'Notifications Are Coming Soon',
      notificationsEmptyDescription:
        'Soon you will be able to send alerts (for example, by email) on inspection events — pass/fail results, upcoming schedules, and neglected assets.',
      sectionNotificationsSummaryEmpty: 'No notifications',
      sectionNotificationsSummaryCount: '{{count}} alert configured',
      sectionNotificationsSummaryCount_plural: '{{count}} alerts configured',
      neglectEnabled: 'Enabled',
      neglectDisabled: 'Disabled',
      neglectPeriodLabel: 'Warning Period',
      neglectFlagAfter: 'Flag after',
      sectionOptional: 'Optional',
      sectionNotSet: 'Not set',
      sectionNotConfigured: 'Not configured',
      sectionInProgress: 'In progress',
      recurrenceDescription:
        'Define how often this inspection should be performed',
      recurrenceNone: 'None',
      recurrenceManual: 'Manual',
      recurrenceScheduled: 'Scheduled',
      recurrenceNoneHint:
        'No recurring schedule. Inspections are created on demand.',
      recurrenceManualHint:
        'Select a date/time field that determines when the next inspection is due.',
      recurrenceScheduleHint:
        'Inspections recur on a calendar schedule you define.',
      recurrenceFieldLabel: 'Date/Time Field',
      recurrenceEvery: 'Every',
      recurrenceEveryLower: 'every',
      recurrenceRepeatsLabel: 'Repeats',
      recurrenceTimeZoneLabel: 'Time Zone',
      recurrenceTimeZoneHint:
        'The zone this schedule is read in — when each time of day falls, and where a day starts and ends for inspections due on a date.',
      frequency_daily: 'Daily',
      frequency_weekly: 'Weekly',
      frequency_monthly: 'Monthly',
      frequency_yearly: 'Yearly',
      frequencyManual: 'Manual',
      unit_hours: 'hours',
      recurrenceDaysOfWeekLabel: 'Repeat On',
      dow_mon: 'Mon',
      dow_tue: 'Tue',
      dow_wed: 'Wed',
      dow_thu: 'Thu',
      dow_fri: 'Fri',
      dow_sat: 'Sat',
      dow_sun: 'Sun',
      recurrenceDueLabel: 'Due',
      recurrenceDueEndOfDay: 'By End of Day',
      recurrenceDueSetTime: 'At a Set Time',
      recurrenceAddHour: 'Add Time',
      recurrenceRemoveHour: 'Remove Time',
      recurrenceDayOfMonthLabel: 'Day of Month',
      recurrenceDayOfMonthLast: 'Last Day',
      recurrenceYearlyOnLabel: 'On',
      recurrenceMonthLabel: 'Month',
      month_1: 'January',
      month_2: 'February',
      month_3: 'March',
      month_4: 'April',
      month_5: 'May',
      month_6: 'June',
      month_7: 'July',
      month_8: 'August',
      month_9: 'September',
      month_10: 'October',
      month_11: 'November',
      month_12: 'December',
      firstDueDateLabel: 'First Due Date',
      firstDueAnchor_today: 'Today',
      firstDueAnchorHint_today: 'Each asset is first due at the first occurrence on or after the day it joins the schedule.',
      firstDueAnchor_date: 'On a Date I Pick',
      firstDueAnchorHint_date: "Each asset is first due at the schedule's first occurrence on or after this date.",
      firstDueAnchor_field: 'From a Date Field on the Asset',
      firstDueAnchorHint_field:
        "Each asset is first due at the schedule's first occurrence on or after its own field date. Assets with an empty field start from today.",
      firstDueOffsetLabel: 'Offset',
      firstDueOffsetUnitLabel: 'Offset Unit',
      firstDueOffsetSuffix: 'after the field date',
      existingDueDatesKeep: 'Keep Current Due Dates',
      existingDueDatesRecomputeAll: 'Recompute All {{count}}',
      unit_days: 'days',
      unit_weeks: 'weeks',
      unit_months: 'months',
      unit_years: 'years',
      scheduleGroupTitle: 'Schedule',
      assetsGroupTitle: 'Assets',
      assetsCount: '{{total}} assets, {{withDueDate}} with a due date',
      onSaveLabel: 'On Save',
      confirmRecurrenceTitle: 'Confirm Schedule',
      confirmRecurrenceSave: 'Save',
      confirmRecurrenceBack: 'Go Back',
      summaryAnd: 'and',
      summaryEveryOne: 'Every {{unit}}',
      summaryEveryN: 'Every {{count}} {{unit}}',
      summaryOnDays: 'on {{days}}',
      summaryTheNth: 'the {{nth}}',
      summaryLastDay: 'the last day',
      summaryByEndOfDay: 'Due by the end of the day',
      summaryAtTimes: 'Due at {{times}}',
      summaryDueInZone: '{{due}}, {{zone}}',
      summaryGrace: 'Inspections completed up to {{count}} {{unit}} before the due date count toward it.',
      graceCeilingError: 'The submission window can be at most {{count}} {{unit}} for this schedule',
      summaryStartsToday: 'Each asset is first due at the first occurrence on or after the day it joins the schedule.',
      summaryStartsDate: 'Each asset is first due at the first occurrence on or after {{date}}.',
      summaryStartsDateMissing: 'No First Due Date picked yet.',
      summaryStartsField: 'Each asset is first due at the first occurrence on or after its own {{field}} date{{offset}}.',
      summaryPlusOffset: 'plus {{count}} {{unit}}',
      summaryUnnamedField: 'the selected field',
      summaryKeepCurrent: '{{count}} of {{total}} assets keep their current due date and follow the new schedule from their next inspection on.',
      summaryRecomputeAll: 'All {{count}} assets move onto the new schedule now.',
      summaryOnSaveKeep: 'On Save: Keep Current Due Dates',
      summaryOnSaveRecompute: 'On Save: Recompute All',
      summaryModeNone: 'No recurring schedule',
      summaryModeManual: "Due on each asset's {{field}} date",
      onSaveHint:
        'Keep: assets stay on their current due date and follow the new schedule from their next inspection on. Recompute: every asset moves onto the new schedule now.',
      earlyWindowLabel: 'Submission Window',
      earlyWindowUpTo: 'up to',
      earlyWindowSuffix: '{{unit}} before the due date',
      earlyWindowHint:
        'Inspections completed within this window count toward the upcoming due date; anything earlier does not. Suggested: a quarter of the time between inspections, up to two weeks. Maximum {{max}} for this schedule.',
      earlyWindowUseSuggested: 'Use Suggested ({{seed}})',
      unit_day: 'day',
      unit_hour: 'hour',
      unit_week: 'week',
      unit_month: 'month',
      unit_year: 'year',
      unsavedChangesTitle: 'Unsaved Changes',
      unsavedChangesMessage:
        'You have unsaved changes to this inspection configuration. If you leave, your changes will be lost.',
      discardChanges: 'Discard Changes',
      keepEditing: 'Keep Editing',
      dateRangePresets: 'Presets',
      dateRangeCustom: 'Custom',
      dateRangePast: 'Past',
      dateRangeFuture: 'Future',
      dateRangeNone: 'None',
      dateRangeAll: 'All',
      dateRangeAllTime: 'All Time',
      dateRangeStartDate: 'Start Date',
      dateRangeEndDate: 'End Date',
      dateRangeDialogLabel: 'Date range',
      dateRangeCustomRange: 'Custom Range',
      dateRangePastSub: 'Performance \u00B7 History',
      dateRangeFutureSub: 'Scheduled',
      dateRangeFromPrefix: 'From {{date}}',
      dateRangeUntilPrefix: 'Until {{date}}',
      dateRangeInputPlaceholder: 'YYYY-MM-DD',
      dateRangeLast7d: 'Last 7 Days',
      dateRangeLast30d: 'Last 30 Days',
      dateRangeLast90d: 'Last 90 Days',
      dateRangeLast12m: 'Last 12 Months',
      dateRangeNext7d: 'Next 7 Days',
      dateRangeNext30d: 'Next 30 Days',
      dateRangeNext90d: 'Next 90 Days',
      dateRangeNext12m: 'Next 12 Months',
      notificationsTitle: 'Notifications',
      notificationsDescription:
        'Configure who gets notified when inspections happen.',
      notificationsGroupPass: 'Pass',
      notificationsGroupFail: 'Fail',
      notificationsGroupScheduledBefore: 'Scheduled Before',
      notificationsGroupScheduledAfter: 'Scheduled After',
      notificationsGroupNeglect: 'Neglect',
      notificationsGroupSummary: 'Summary',
      notificationsGroupPassDesc:
        'Notify recipients when an inspection passes.',
      notificationsGroupFailDesc: 'Notify recipients when an inspection fails.',
      notificationsGroupScheduledBeforeDesc:
        'Remind recipients ahead of a scheduled inspection.',
      notificationsGroupScheduledAfterDesc:
        'Follow up with recipients after a scheduled inspection.',
      notificationsGroupNeglectDesc:
        'Alert recipients the first time an asset crosses the neglect threshold.',
      notificationsGroupSummaryDesc:
        'Send recipients a periodic digest of inspection activity.',
      notificationsDisabledPassFail:
        'Set up Pass/Fail Criteria to enable these alerts.',
      notificationsDisabledRecurrence:
        'Set up Recurrence to enable scheduled alerts.',
      notificationsDisabledNeglect:
        'Enable Neglect Warnings to configure these alerts.',
      notificationsConfigureLink: 'Configure',
      notificationsRecipientsHint: 'Add at least one email recipient.',
      notificationsOffsetPrefix: 'Send',
      notificationsSummaryLabelSend: 'Send',
      notificationsSummaryLabelAt: 'at',
      notificationsSummaryLabelOn: 'on',
      notificationsAddAlert: 'Add Alert',
      notificationsRemoveAlert: 'Remove',
      notificationsOffsetAmount: 'Amount',
      notificationsOffsetUnitDays: 'days',
      notificationsOffsetUnitWeeks: 'weeks',
      notificationsOffsetUnitMonths: 'months',
      notificationsOffsetUnitYears: 'years',
      notificationsCadenceDaily: 'Daily',
      notificationsCadenceWeekly: 'Weekly',
      notificationsCadenceMonthly: 'Monthly',
      notificationsTimeOfDay: 'Time of Day',
      notificationsDayOfWeek: 'Day of Week',
      notificationsDayOfMonth: 'Day of Month',
      notificationsDayOfMonthHint: '1-28',
      notificationsDowSunday: 'Sunday',
      notificationsDowMonday: 'Monday',
      notificationsDowTuesday: 'Tuesday',
      notificationsDowWednesday: 'Wednesday',
      notificationsDowThursday: 'Thursday',
      notificationsDowFriday: 'Friday',
      notificationsDowSaturday: 'Saturday',
      notificationsRecipients: 'Recipients',
      notificationsAddEmail: 'Add Email',
      notificationsRemoveEmail: 'Remove email',
      notificationsEmailInvalid: 'Invalid email address',
      notificationsRecipientsRequired: 'At least one recipient is required',
      notificationsValidationOffsetRequired: 'Offset amount is required',
      notificationsValidationTimeRequired: 'Time of day is required',
      notificationsValidationDayOfWeekRequired: 'Day of week is required',
      notificationsValidationDayOfMonthRequired:
        'Day of month is required (1-28)',
    },
    customModule: {
      loadFailedTitle: 'Unable to Load Module',
      loadFailedDescription:
        'The module content could not be loaded. Please check your connection and try again.',
      retry: 'Retry',
    },
    fields: {
      text: 'Text',
      boolean: 'Boolean',
      selector: 'Selector',
      number: 'Number',
      location: 'Location',
      email: 'Email',
      url: 'Url',
      phone: 'Phone',
      dateTime: 'Date/Time',
      photo: 'Photo',
      journal: 'Journal',
      records: 'Records',
      image: 'Image',
      group: 'Group',
      description: 'Description',
    },
    widgets: {
      storage: 'Storage',
      total: 'Total',
      perSlate: 'per Slate',
    },
  },
};
